import CryptoJS from 'crypto-js';

/**
 * @param {string} userId
 * @returns {string}
 */
const deriveEncryptionKey = userId => {
  const appSalt = process.env.REACT_APP_ENCRYPTION_SALT || 'disgenet-filters-2025';

  const key = CryptoJS.PBKDF2(userId, appSalt, {
    keySize: 256 / 32,
    iterations: 10000,
  });

  return key.toString();
};

/**
 * @param {Array} filters
 * @param {string} userId
 * @returns {string}
 */
export const encryptFilters = (filters, userId) => {
  try {
    if (!userId) {
      throw new Error('User ID is required for encryption');
    }

    const key = deriveEncryptionKey(userId);
    const jsonString = JSON.stringify(filters);

    const encrypted = CryptoJS.AES.encrypt(jsonString, key);

    return encrypted.toString();
  } catch (error) {
    console.error('Error encrypting filters:', error);
    throw error;
  }
};

/**
 * @param {string} encryptedData
 * @param {string} userId
 * @returns {Array}
 */
export const decryptFilters = (encryptedData, userId) => {
  try {
    if (!userId) {
      throw new Error('User ID is required for decryption');
    }

    if (!encryptedData) {
      return [];
    }

    const key = deriveEncryptionKey(userId);

    const decrypted = CryptoJS.AES.decrypt(encryptedData, key);
    const jsonString = decrypted.toString(CryptoJS.enc.Utf8);

    if (!jsonString) {
      return [];
    }

    return JSON.parse(jsonString);
  } catch {
    return [];
  }
};

/**
 * @param {string} encryptedData
 * @param {string} userId
 * @returns {boolean}
 */
export const verifyEncryption = (encryptedData, userId) => {
  try {
    const decrypted = decryptFilters(encryptedData, userId);
    return Array.isArray(decrypted);
  } catch {
    return false;
  }
};
